// extracted by mini-css-extract-plugin
export default {"root":"PlasmicLogoInDock_root__aKsEG"};